import { Controller } from "@hotwired/stimulus"

// Modal controller for showing/hiding modal dialogs
// Usage (with ID):
//   <div data-controller="modal">
//     <button data-action="modal#open" data-modal-target-param="my-modal">Open Modal</button>
//     <div id="my-modal" class="hidden" data-modal-target="dialog">
//       <button data-action="modal#close">Close</button>
//     </div>
//   </div>
//
// Usage (with container target):
//   <div data-controller="modal">
//     <button data-action="modal#open">Open Modal</button>
//     <div class="hidden" data-modal-target="container">
//       <button data-action="modal#close">Close</button>
//     </div>
//   </div>

export default class extends Controller {
  static targets = ["dialog", "backdrop", "container"]

  open(event) {
    // First check if there's a target param (ID-based approach)
    const modalId = event.params?.target
    let modal = modalId ? document.getElementById(modalId) : null

    // Fall back to container target if no ID specified
    if (!modal && this.hasContainerTarget) {
      modal = this.containerTarget
    }

    if (modal) {
      modal.classList.remove("hidden")
      document.body.classList.add("overflow-hidden")

      // Focus first focusable element in modal
      const focusable = modal.querySelector('input, button, select, textarea, [tabindex]:not([tabindex="-1"])')
      if (focusable) {
        setTimeout(() => focusable.focus(), 100)
      }
    }
  }

  close(event) {
    // Find the closest modal dialog and hide it
    const modal = event.target.closest('[data-modal-target="container"]') ||
                  event.target.closest('[data-modal-target="dialog"]') ||
                  event.target.closest('.fixed.inset-0')
    if (modal) {
      modal.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }
  }

  closeAll() {
    this.dialogTargets.forEach(dialog => {
      dialog.classList.add("hidden")
    })
    document.body.classList.remove("overflow-hidden")
  }

  // Close on escape key
  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.closeAll()
    }
  }

  connect() {
    document.addEventListener("keydown", this.closeOnEscape.bind(this))
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape.bind(this))
  }
}
